// extracted by mini-css-extract-plugin
module.exports = {"testing-container":"_3xPVh","testing-popup":"_2W53B","testing-popup-close":"pKitl","btn-close":"_2RP6J","icon-cross":"_3BXp7"};